import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

//login Page
import Login from './components/Login/Login';

//context Auth Provider
import { AuthProvider } from './context/auth';

//protected Routes
import { ProtectedRoute } from './ProtectedRoutes';

//mainLayout
import Layout from './components/Layout/Layout';

//Dashboard Screen start
import Dashboard from './components/Dashboard/Dashboard';
//Dashboard Screen End

import PageNotFound from './components/commoncomponents/PageNotFound';
import PDFView, { ImageView } from './components/commoncomponents/PdfView';

// User Master
import ChangePassword from './components/User Master/ChangePassword';
//import ResetPassword from './components/User Master/ResetPassword';

//Reports
import AttendanceDetailReport from './components/Reports/AttendanceDetailReport';
import DocumentReport from './components/Reports/DocumentReport';
import ESICReport from './components/Reports/ESICReport';
import LWFReport from './components/Reports/LWFReport';
import LeaveStatusReport from './components/Reports/LeaveStatusReport';
import PFReport from './components/Reports/PFReport';
import PTaxReport from './components/Reports/PTaxReport';
import ViewCompanyPolicy from './components/Reports/ViewCompanyPolicy';
//Print
import Payslip from './components/Print/Payslip';

//Leave Management
import CompOffLeaveApplication from './components/Leave Management/CompOffLeaveApplication';
import LeaveApplication from './components/Leave Management/LeaveApplication';
import LeaveApproval from './components/Leave Management/LeaveApproval';
import LeaveStatus from './components/Leave Management/LeaveStatus';
import MonthlyCreditStatement from './components/Print/MonthlyCreditStatement';

import AttendanceRequisition from './components/EmployeeMaster/AttendanceRequisition';

function App() {
    return (
        <>
            <ToastContainer position={'top-center'} />
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route exact path='Dashboard/EmployeeDashboard' element={<Dashboard />} />

                            {/*User Master  */}
                            <Route exact path='User/ChangePassword' element={<ChangePassword />} />
                            {/*<Route exact path='User/ResetPassword' element={<ResetPassword />} />*/}


                            {/*Reports  */}
                            <Route exact path='Report/PFReport' element={<PFReport />} />
                            <Route exact path='Report/ESICReport' element={<ESICReport />} />
                            <Route exact path='Report/LWFReport' element={<LWFReport />} />
                            <Route exact path='Report/PTaxReport' element={<PTaxReport />} />
                            <Route exact path='Report/AttendanceDetailReport' element={<AttendanceDetailReport />} />
                            <Route exact path='Report/LeaveStatusReport' element={<LeaveStatusReport />} />
                            <Route exact path='Report/DocumentReport' element={<DocumentReport />} />
                            <Route exact path='Report/ViewCompanyPolicy' element={<ViewCompanyPolicy />} />

                            {/*Print*/}
                            <Route exact path='Print/Payslip' element={<Payslip />} />
                            <Route exact path='Print/MonthlyCreditStatement' element={<MonthlyCreditStatement />} />

                            {/*Leave Management */}
                            <Route exact path='LeaveManagement/CompOffLeaveApplication' element={<CompOffLeaveApplication />} />
                            <Route exact path='LeaveManagement/LeaveApplication' element={<LeaveApplication />} />
                            <Route exact path='LeaveManagement/LeaveApproval' element={<LeaveApproval />} />
                            <Route exact path='LeaveManagement/LeaveStatus' element={<LeaveStatus />} />

                            <Route exact path='Employee/AttendanceRequisition' element={<AttendanceRequisition />} />

                        <Route path='*' element={<PageNotFound />} />
                        </Route>
                        <Route exact path='/' element={<Login />} />
                        {/*<Route exact path='/forgotPassword' element={<ForgotPasswordSlide1 />} />*/}
                        <Route exact path='/PdfView' element={<PDFView />} />
                        <Route exact path='/ImageView' element={<ImageView />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </>
    );
}

export default App;
